import { useState } from 'react';
import { ProductApiModel } from '~/lib/api/smartsend/types';

import Loading from '../../../../components/loading/Loading';
import { ProductList } from './ProductList';
import { Tagged } from '../Tagged';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { P2GImageMessage } from '~/components/imagemessage';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  products: () => Promise<ProductApiModel[]>;
  onSelect: (p: ProductApiModel) => void;
  children: React.ReactNode;
}
export const ProductSelector: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState<ProductApiModel[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const load = () => {
    setOpen(true);
    setLoading(true);
    props.products().then((r) => {
      setProducts(r);
      setLoading(false);
    });
  };

  const onSelect = (p: ProductApiModel) => {
    props.onSelect(p);
    setOpen(false);
  };

  if (!props.products) {
    return null;
  }

  return (
    <>
      <P2GBox component="span" onClick={load}>
        {props.children}
      </P2GBox>
      <P2GSidePanel
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={t('PRODUCTS_SIDEPANEL_TITLE', { defaultValue: 'Products' })}
      >
        <Tagged tag="panel-products">
          {loading ? (
            <Loading />
          ) : products.length === 0 ? (
            <P2GImageMessage
              message={t('NO_RESULTS_FALLBACK', { defaultValue: 'No Results' })}
              image="/theme/common/notifications/no-results.png"
              contentKey="image-smartsend-products-empty-list"
            />
          ) : (
            <ProductList products={products} onSelect={onSelect} />
          )}
        </Tagged>
      </P2GSidePanel>
    </>
  );
};
